export default "__VITE_ASSET__BVO0te5k__"